import { Flex } from "@chakra-ui/react";
import Many from './components/many';
import Baseline from './components/baseline';
import Features from './components/features';
import CallToAction from './components/callToAction';
import Faq, { buildFaqJsonLd } from './components/faq';
import SEO from '../components/SEO';
import { useTranslation } from '../i18n/LanguageContext';
import { buildPageUrl, SITE_URLS } from '../lib/seo/constants';

export default function HomePage() {
  const { lang, t } = useTranslation();

  const homeJsonLd = [
    {
      "@type": "SoftwareApplication",
      "name": "Bibliona",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "url": buildPageUrl(lang, '/'),
      "image": `${SITE_URLS[lang] || SITE_URLS.en}/img/og-image.png`,
      "description": t("jsonld.home.description"),
      "offers": [
        {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock",
          "url": buildPageUrl(lang, '/pricing'),
          "name": t("pricing.basic"),
          "description": t("jsonld.home.basic.description"),
        },
        {
          "@type": "Offer",
          "price": "1.99",
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock",
          "url": buildPageUrl(lang, '/pricing'),
          "name": t("pricing.pro"),
          "description": t("jsonld.home.pro.description"),
        },
      ],
    },
    buildFaqJsonLd(t),
  ];

  return (
    <main>
      <SEO
        path="/"
        description={t("seo.home.description")}
        jsonLd={homeJsonLd}
      />
      <Flex
        as="article"
        flexDirection={"column"}
        alignItems={"center"}
        p={"20px"}
        borderRadius={"20px"}
        paddingTop={"0"}
      >
        <Baseline />
        <Many />
        <Features />
        <CallToAction />
        <Faq />
      </Flex>
    </main>
  );
}
